import React from 'react';
import { useConnect } from '@lore/query-connect';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import Urls from '../event-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function School(props) {
  const { event } = props;
  const { history } = usePageRouter();

  const site = useConnect('site.byId', {
    id: event.data.siteId
  }, {
    enabled: !!event.data.siteId
  });

  if (!event.data.siteId) {
    return (
      <DataCard
        title="School"
        icon={BuildingOfficeIcon}
        subtitle="(not provided)"
        onClick={() => history.push(Urls(event).SCHOOL)}
      />
    );
  }

  return (
    <DataCard
      title="School"
      icon={BuildingOfficeIcon}
      subtitle={site.data.name || '...'}
      onClick={() => history.push(Urls(event).SCHOOL)}
    />
  );
};
